import { useField } from "formik";
import { isEmpty, isNil } from "lodash";
import React from "react";
import { RadioInput } from "../Common/RadioInput";
import { QuestionnaireDescription } from "../Questionnaire/QuestionnaireDescription";
import { FieldProps } from "../Questionnaire/TextField";
import { FormField } from "./FormField";

export const RadioField = ({ name, field, onChange, initialValue, classNames }: FieldProps) => {
    const [props, , helpers] = useField(name);
    const handleChange = (value: string) => {
        helpers.setValue(value);
        onChange?.(value);
    };

    if (isEmpty(props.value) && !isEmpty(initialValue) && props.value !== initialValue) {
        helpers.setValue(initialValue);
    }

    return (
        <FormField name={name} label={field.label} classNames={{ label: classNames?.label }}>
            <QuestionnaireDescription field={field} className={classNames?.description} />
            <div className="leading-2 flex space-x-4">
                <RadioInput checked={props.value === "Yes"} onChange={() => handleChange("Yes")}>
                    Yes
                </RadioInput>
                <RadioInput checked={props.value === "No"} onChange={() => handleChange("No")}>
                    No
                </RadioInput>
            </div>
        </FormField>
    );
};
